var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNbWifiPhone(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 25 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6DA4A933-CEF2-49E8-8DCE-1F4DEA88179E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-wifi-access-create1",
    transform: "translate(-218.000000, -423.000000)",
    fill: "#76778C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.515625,423.191264 C219.139486,423.191264 218,424.394765 218,425.848216 L218,467.006221 C218,468.45963 219.139486,469.663174 220.515625,469.663174 L240.484375,469.663174 C241.860514,469.663174 243,468.45963 243,467.006221 L243,425.848216 C243,424.394765 241.860514,423.191264 240.484375,423.191264 L220.515625,423.191264 Z M220.515625,425.303623 L240.484375,425.303623 C240.787109,425.303623 241,425.528473 241,425.848216 L241,428.010084 L220,428.010084 L220,425.848216 C220,425.528473 220.212891,425.303623 220.515625,425.303623 Z M220,430.122443 L241,430.122443 L241,458.952851 L220,458.952851 L220,430.122443 Z M220,461.06521 L241,461.06521 L241,467.006221 C241,467.325927 240.787109,467.550814 240.484375,467.550814 L220.515625,467.550814 C220.212891,467.550814 220,467.325927 220,467.006221 L220,461.06521 Z M230.40625,463.06205 C230.00977,463.06205 229.662307,463.245844 229.421875,463.524129 L227.453125,463.524129 C227.421892,463.522581 227.390608,463.522581 227.359375,463.524129 C227.002058,463.541743 226.68079,463.759381 226.516618,464.095041 C226.352445,464.430702 226.370316,464.833375 226.563498,465.151343 C226.75668,465.469311 227.095815,465.654254 227.453125,465.636488 L230.0625,465.636488 C230.176742,465.669009 230.281586,465.685997 230.40625,465.685997 C230.530914,465.685997 230.651383,465.669009 230.765625,465.636488 L233.546875,465.636488 C233.90751,465.641874 234.242954,465.441753 234.42476,465.112756 C234.606565,464.783759 234.606565,464.376858 234.42476,464.047861 C234.242954,463.718864 233.90751,463.518743 233.546875,463.524129 L231.40625,463.524129 C231.165818,463.245844 230.80273,463.06205 230.40625,463.06205 Z",
    id: "nb_wifi_phone"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNbWifiPhone);
export default __webpack_public_path__ + "static/media/nb-wifi-phone.74bb8889285e3f9b4f322b656b6a849a.svg";
export { ForwardRef as ReactComponent };